import { StyledHTMLFieldsBlock } from 'components/StyledHTMLFiledsBlock/StyledHTMLFieldsBlock';
import s from './CreateDefaultMessage.module.scss';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ValidateTextFields } from 'utils/validation';
import { useStatusContext } from 'components/StatusProvider';
import { PrimaryButton } from 'components/PrimaryButton/PrimaryButton';
import { SecondaryButton } from 'components/SecondaryButton/SecondaryButton';
import { useNavigate, useParams } from 'react-router-dom';
import { useCreateQuestionMutation, useGetQuestionMutation, useUpdateQuestionMutation } from '../../../../../redux/apis/supportApi';
import { Skeleton } from 'components/Skeleton/Skeleton';

export const CreateDefaultMessage = () => {

    // ### State
    const langs = useSelector((store: any) => store.main.langs);
    const [activeLang, setActiveLang] = useState<string>(langs?.[0]?.key)
    const [form, setForm] = useState({
        question: {},
        answer: {}
    })

    const status = useStatusContext()
    const {t} = useTranslation()
    const navigate = useNavigate()
    const {id} = useParams()

    const[CreateQuestion, {isLoading: isCreateLoading}] = useCreateQuestionMutation()
    const[UpdateQuestion, {isLoading: isUpdateLoading}] = useUpdateQuestionMutation()
    const[GetQuestion, {isLoading: isGetLoading}] = useGetQuestionMutation()

    // ### Effects
    useEffect(()=>{
        if(id){
            getQuestion(Number(id))
        }
    },[id]);

    // ### Functions
    async function getQuestion(id: any){
        const response = await GetQuestion({id})
        if(response?.data?.length) setForm(response.data?.[0])
    }
    
    async function handleCreate(){
        let error
        if(!ValidateTextFields(form.question, langs)) error = "support.errors.question"
        if(!ValidateTextFields(form.answer, langs)) error = "support.errors.answer"

        if(error){
            status.openStatus('error', error)
            return
        }
        let action = id ? UpdateQuestion : CreateQuestion
        const response = await action(form)
        if(response.data?.message === "created" || response.data?.message === "updated"){
            status.openStatus("success", "") 
            navigate('/support/settings')
        }
        else status.openStatus('error', "Error")
    }

    // ### Views

     return(
        <div className={s.messages_wrapper}>
            <div className={s.message}>
                <div className={s.question}>
                    <StyledHTMLFieldsBlock 
                        height={200}
                        values={form.question}
                        title={t('support.question')}
                        changeValue={(value)=> {setForm((prev: any) => ({...prev, question: {...prev.question, ...value}}))}}
                        activeLang={activeLang}
                        setActiveLang={setActiveLang}
                    />
                </div>
                <div className={s.answer}>
                    <StyledHTMLFieldsBlock
                        height={200}
                        values={form.answer}
                        title={t('support.answer')}
                        changeValue={(value)=> {setForm((prev: any) => ({...prev, answer: {...prev.answer, ...value}}))}}
                        activeLang={activeLang}
                        setActiveLang={setActiveLang}
                    />
                </div>
            </div>
            <div className={s.footer}>
                <PrimaryButton 
                    text='Save'
                    type={"button"}
                    style={{width: "fit-content"}}
                    onClick={handleCreate}
                    disabled={(isCreateLoading || isUpdateLoading)}
                />

                <SecondaryButton
                    text='Back'
                    type={"button"}
                    style={{width: "fit-content"}}
                    onClick={() => navigate('/support/settings')}
                />
            </div>
            <Skeleton isLoading={isGetLoading} />
        </div>
    )
}